import PropTypes from 'prop-types'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import styles from '../../../styles/bantrab/components/card.module.scss'

import Body from './body'
import Dropdown from './dropdown'
import Blog from './blog'
import BlogMediun from './blogMediun'
import RecursoMediun from './recursoMediun'
import RecursoLarge from './recursoLarge'
import CursoMediun from './cursoMediun'
import WebinarMediun from './webinarMediun'
import BlogSmall from './blogSmall'
import Buy from './buy'
import CourseSmallDefault from './courseSmallDefault'
import CourseMediumDefault from './courseMediumDefault'
import CardBigDefault from './cardBigDefault'
import BlogxSmall2 from './blogxSmall2'

const Media = dynamic(() => import('./media'), { ssr: false })

const Card = ({ children, color, horizontal, floated, icon, ...attrs }) => {


  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.card]: true,
    [styles[color]]: !!color,
    [styles.icon]: icon,
    [styles.floated]: floated,
    [styles.horizontal]: horizontal,

  })

  return (
    <div {...attrs}>
      {children}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  color: PropTypes.string,
  horizontal: PropTypes.any,
  floated: PropTypes.any,
  icon: PropTypes.any
}
Card.Media = Media
Card.Body = Body
Card.Dropdown = Dropdown
Card.Blog = Blog
Card.BlogMediun = BlogMediun
Card.RecursoMediun = RecursoMediun
Card.RecursoLarge = RecursoLarge
Card.CursoMediun = CursoMediun
Card.WebinarMediun = WebinarMediun
Card.BlogSmall = BlogSmall
Card.CardBigDefault = CardBigDefault
Card.BlogxSmall2 = BlogxSmall2

Card.Buy = Buy
Card.CourseSmallDefault = CourseSmallDefault
Card.CourseMediumDefault = CourseMediumDefault

export default Card
